import { render, staticRenderFns } from "./BookingsListLiteTable.vue?vue&type=template&id=4f72244e&scoped=true"
import script from "./BookingsListLiteTable.vue?vue&type=script&lang=js"
export * from "./BookingsListLiteTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f72244e",
  null
  
)

export default component.exports